import Vue from 'vue'

const app = new Vue({
  el: '#app',

  mounted() {
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty("--vh", `${vh}px`)

    window.addEventListener("resize", () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty("--vh", `${vh}px`)
    })
  },

  data () {
    return {
      menuOpen: false
    }
  },

  methods: {
    toggleMenu () {
      this.menuOpen = ! this.menuOpen
    }
  }
})

export default app
